/**
 * Scroll helpers for sticky-header-aware section navigation.
 *
 * We rely on CSS `scroll-margin-top: 88px` (index.css) so that native
 * `scrollIntoView()` lands with correct offset for the sticky navbar.
 */

/** Smooth-scroll to an element by id, honouring the sticky nav offset. */
export function scrollToSection(anchor) {
  if (!anchor) return false;
  const el = document.getElementById(anchor);
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  return true;
}

/**
 * Navigate to a homepage section from anywhere in the app.
 * - On the homepage: smooth-scroll immediately.
 * - Elsewhere: navigate to `/#anchor`; the Landing page's mount effect
 *   picks it up and scrolls once the section has rendered.
 */
export function goToSection({ nav, isLanding, anchor }) {
  if (!anchor) return;
  if (isLanding) {
    if (!scrollToSection(anchor)) {
      window.location.hash = anchor;
    }
    return;
  }
  nav(`/#${anchor}`);
}
